module.exports = __webpack_public_path__ + "media/images/aloe/icons/line/shipping-d4e72b295c9067917d6cced1a45229e4.svg";